import *  as _ from "lodash";
import *  as Dialog from "./dialog";
import *  as Loading from "./loading";
import * as constant from "./define/constant";
import { Business } from "./business";

/**
 * 
 */
//export default class Util {
export class Util {

    /** C# min */

    //C＃ 日付（最小で "0001年1月1日 0時0分0秒"、最大で "9999年12月31日 23時59分59秒" ）
    //javascript 日付（紀元前271821年4月20日 - 紀元275760年9月13日 ）

    //C#では下記だが、JSでは、下記は2001年判断になるので
    //static readonly MIN_DATETIME: Date = new Date('0001/01/01 00:00:00');
    //一旦100年としておく
    static readonly MIN_DATETIME: Date = new Date('0100/01/01 00:00:00');
    /** C# Max */
    static readonly MAX_DATETIME: Date = new Date('9999/12/31 23:59:59');

    /***/
    static readonly window = {

        /**/
        subWindowNames: {
            ProcessManagement: 'ProcessManagement',
            ProgressManagement: 'ProgressManagement',
            ViewProgress: 'ViewProgress',
            ReHold: 'ReHold',
            ScheduleApproval: 'ScheduleApproval',
            ScheduleExport: 'ScheduleExport',
            Summary: 'Summary',
            SummaryGraph: 'SummaryGraph',
            SummaryMeeting: 'SummaryMeeting',
            SummaryIncomplete: 'SummaryIncomplete',
            SummaryWhole: 'SummaryWhole'

        },

        /***/
        opendWinds: [],

        /**
         * 
         * @param url
         * @param method
         * @param windowName
         * @param isSuffixDateTime
         * @param params
         */
        open: function (url, method, windowName, isSuffixDateTime, params) {
            //let windowWidth = $(window).width();
            //let windowHeight = $(window).height();
            if (isSuffixDateTime) {
                const date = new Date();
                windowName += date.getTime();
            }


            //新規window
            //const newWindow = window.open('about:blank', windowName, 'width=' + windowWidth + ',height=' + windowHeight + ', location=yes, toolbar=yes, resizable=yes, scrollbars=yes');
            //新規Tab(windowFeatures を指定しないことでTABになる)
            //const newWindow = window.open('about:blank', windowName);

            //#2836 【不具合】ITA_V_04_PROG_003_1_006他_進捗表カレンダーにて未保存で他画面遷移した場合のダイアログが2度表示される
            //下記の方式だとbeforeUnloadが2度走ってしまう、現状も使用していない機能なのでので廃止！

            //if (windowName && windowName != '_blank') {
            //    //新規Tab(windowFeatures を指定しないことでTABになる)
            //    const newWindow = window.open('about:blank', windowName);
            //    //
            //    Util.window.opendWinds.push(newWindow);
            //}

            // #4354 iphone safariで既に開かれているwindowの場合切り替わらないので一旦閉じる対応を入れる
            // モバイル判定する必要は正直ないが、PCの場合特に問題がないので、影響範囲を狭めるため条件にしておく。
            if (Util.userAgent.isMobile) {
                if (windowName && !(windowName == '_blank' || windowName == '_self')) {
                    const targetWindow = window.open('', windowName);
                    // 開いたwindowのurlが about:blank だったら、空windowが開けたことになる
                    if (targetWindow.location.href != 'about:blank') {
                        // windowのurlが about:blank ではなかった場合、既にそのwindowは存在しているので一旦閉じる
                        targetWindow?.close();
                    }
                }
            }

            const form = $('<form/>', { action: url, method: method, target: windowName });
            $.each(params, function (key, value) {
                form.append($('<input/>', { name: key, value: value }));
            });

            //#1783 CSRF対策
            //通常リクエストの場合、POSTの場合のみCSRFトークンを付加する（getだとLocationにQueryStringとして出てしまう）
            if (method === 'post') {
                //cookieからCSRFトークン取得
                const csrfToken = Util.getCSRFToken();
                //ASP.NETデフォルト'__RequestVerificationToken'。
                //Headerに含めず、リクエストリクエストに含める場合はこの名前、
                form.append($('<input/>', { name: '__RequestVerificationToken', value: csrfToken }));

                //#2612 最終projectCodeではなくprojectIdの引き回し運用とする(sessionProjectInfo廃止検討)
                //セッションにプロジェクト情報を保持しなくなる為、プロジェクトコードを都度パラメータに含める
                let projectId = Util.getProjectId();
                form.append($('<input/>', { name: '_projectId', value: projectId }));
                let projectCode = Util.getProjectCode();
                form.append($('<input/>', { name: '_projectCode', value: projectCode }));
            }

            form.appendTo(document.body);
            form.submit().remove();
        },

        /** *  */
        location: {
            /**
             * 
             * @param name
             * @param url
             */
            getParam: function (name, url?) {
                url = window.location.href || url
                name = name.replace(/[\[\]]/g, "\\$&");
                let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                    results = regex.exec(url);
                if (!results) { return null; }
                if (!results[2]) { return ''; }
                return decodeURIComponent(results[2].replace(/\+/g, " "));
            }
        },

        /** 
         *  
         *    */
        checkEdited: {
            /**
             * 
             * @param name
             * @param url
             */
            getParam: function (name, url?) {
                url = window.location.href || url
                name = name.replace(/[\[\]]/g, "\\$&");
                let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                    results = regex.exec(url);
                if (!results) { return null; }
                if (!results[2]) { return ''; }
                return decodeURIComponent(results[2].replace(/\+/g, " "));
            }
        },

        /**
         * 画面のUnloaf監視、SPIRIT管理の子画面を全て閉じる
         */
        onCloseSubWindow() {
            // CLOSE
            //window.addEventListener('unload', function (event) {
            window.addEventListener('beforeunload', function (event) {
                //debugger;
                //強制全クローズ
                Util.window.closeSubWindow();
            });
        },

        /**
         * SPIRIT管理の子画面を全て閉じる（ちらつく）
         */
        closeSubWindow() {

            //強制全クローズ
            for (let name in Util.window.subWindowNames) {
                var winObj = window.open('', name);        //サブwindowを空画面で上書き
                winObj?.close();
            }
        },


        //#2836 【不具合】ITA_V_04_PROG_003_1_006他_進捗表カレンダーにて未保存で他画面遷移した場合のダイアログが2度表示される
        /**
         * 
         * コッチできっちり行えればちらつきはない
         * ただしF５をされた段階で、メモリ上から消えてしまうので
         * 保管領域をどうにかする必要がある
         * @deprecated
         */
        //onCloseMagnagedWindow() {
        //    // CLOSE
        //    //window.addEventListener('unload', function (event) {
        //    window.addEventListener('beforeunload', function (event) {
        //        //debugger;
        //        Util.window.opendWinds.forEach(subWindow => {
        //            subWindow?.close();
        //        });

        //    });
        //},


    }

    /**
     * 
     * @param arg
     * @param isErrorHandling ダウンロードはfalse
     */
    static ajax(arg, isErrorHandling = true) {
        //cookieからCSRFトークン取得
        const csrfToken = Util.getCSRFToken();
        //#2612 最終projectCodeではなくprojectIdの引き回し運用とする(sessionProjectInfo廃止検討)
        //セッションにプロジェクト情報を保持しなくなる為、プロジェクトコードを都度パラメータに含める
        let projectId = Util.getProjectId();
        let projectCode = Util.getProjectCode();
        //beforeSend内では、追加データをパラメータに含めるのが難儀(既に良い感じでescape掛かっている)
        //dataとして含めてしまう(getの場合はQueryパラメータに含まれるようになる)
        arg.data = arg.data || {};
        if (projectCode) {
            // Ajaxでファイルアップロードする場合、FormDataのため通常のObjectと異なる！
            if (arg.data.toString().indexOf('FormData') > -1) {
                // 何かいい条件分あれば変えたい。
                arg.data.append('_projectId', projectId);
                arg.data.append('_projectCode', projectCode);
            } else {
                //extendだと元のarg.dataを侵してしまうので
                //$.extend(arg.data, { projectCode: projectCode });
                //defaultsにする
                _.defaults(arg.data, { _projectId: projectId });
                _.defaults(arg.data, { _projectCode: projectCode });
            }
        }

        //$.ajaxSettings.cache = false;
        //const opt = $.extend({}, $.ajaxSettings, { cache: false }, arg);
        const opt = $.extend({}, $.ajaxSettings, {
            cache: false,
            //#1783 CSRF対策
            //※実は下記はいらないのでは？
            //デフォルトの.AspNetCore.AntiforgeryのCoookieが
            //Startup.csのoptions.Filters.Add(new AutoValidateAntiforgeryTokenAttribute());
            //を追記しただけでで有効になってるかも!!

            beforeSend: function (xhr, settings) {
                //【Angularやaxiosに合わせておく】
                //なぜX-XSRF-TOKENという名前にするかというと、Angularやaxiosなどのクライアントのajaxライブラリでは、
                //レスポンスされたXSRF - TOKEN（cookieのXSRF - TOKEN）の値を、
                //リクエスト時に「X-XSRF-TOKEN」という名前でリクエストヘッダに含める動作を自動的に行っているためです。
                //トークンの名前を合わせておけば、クライアント側でリクエストヘッダにXSRFトークンを追加するような処理を実装する必要がなくなります。
                //X-XSRF-TOKENのキー名でTokenをチェックさせます。
                if (csrfToken) {
                    xhr.setRequestHeader("X-XSRF-TOKEN", csrfToken);
                }
            }
        }, arg);

        const jqXHR = $.ajax(opt);
        const deferred = $.Deferred();
        // Ajax通信成功時
        jqXHR.done(function (data, statusText, jqXHR) {
            // 共通処理
            // 呼ばれ元のdoneを実行
            deferred.resolveWith(this, arguments);
        });
        // Ajax通信失敗時
        jqXHR.fail(function (jqXHR, statusText, errorThrown) {
            // 共通処理
            // 呼ばれ元のfailを実行
            deferred.rejectWith(this, arguments);

            Loading.loading.hide();

            let isDev = false;
            let errInfo = null;
            try {
                // 本番の場合、JSONで返却される
                errInfo = JSON.parse(jqXHR.responseText)
            }
            catch (e) {
                // 開発の場合、.coreのUseDeveloperExceptionPageを使用するためhtml or text が返却される
                isDev = true;
            }

            if (isErrorHandling) {
                // エラーのハンドリングをする場合
                //#4047 
                if (jqXHR.status == 401) {

                    //#7177
                    //「401」で返却されるケースは恐らくないだろう（概ね「408」で返ってくるになる）
                    ////let current = window.location.href;
                    //const $errContainer = $(`<div class="mb-3">${errInfo.detail}</div><div>再度ログインしてください。</div><div>エラー発生日時：${errInfo.instance}</div>`);
                    //Dialog.MessgeDialog(errInfo.title, $errContainer, (res) => {
                    //    //OKであろうがなんであろうが、reloadする
                    //    //if (res === 'ok') {
                    //    //現在のtofFrameNavigationのURLをリロードする
                    //    //セッション（認証）が有効で無い場合、ログイン画面へリダイレクトされるだろう
                    //    //その後、そのままログインすれば、現在のページに戻ってくる想定!!
                    //    this.immediateRlead();
                    //    //}
                    //});
                    //return;

                    //エラーダイアログを表示、画面のリロード
                    Util.immediateRleadDialog(errInfo);
                    
                } else if (jqXHR.status == 408) {

                    //エラーダイアログを表示、画面のリロード
                    Util.immediateRleadDialog(errInfo);

                } else {
                    if (!isDev) {

                        const $errContainer = $(`<div class="mb-3">${errInfo.detail}</div><div>システム管理者へお問い合わせ下さい。</div><div>エラー発生日時：${errInfo.instance}</div>`);

                        Dialog.MessgeDialog(errInfo.title, $errContainer, (res) => {
                            //if (res === 'ok') {
                            //}
                        });

                    } else {

                        const $errContainer = $('<div style="max-width: 1000px; max-height: 550px; overflow: auto;"></div>');
                        $errContainer.html(jqXHR.responseText);

                        Dialog.MessgeDialog('システムエラー', $errContainer, (res) => {
                            //if (res === 'ok') {
                            //}
                        });

                    }
                }

            }
        });
        // Ajax処理完了
        jqXHR.always(function () {
            // 共通処理

        });
        // Deferred ObjectのPromiseを返却
        return $.extend({}, jqXHR, deferred.promise());
    }

    /**
     * ブラウザを強制的にリロードする
     */
    static immediateRleadDialog(errInfo: { title; detail; instance }) {
        const $errContainer = $(`<div class="mb-3">${errInfo?.detail}</div><div>再度ログインしてください。</div><div>エラー発生日時：${errInfo?.instance}</div>`);
        Dialog.MessgeDialog(errInfo?.title, $errContainer, (res) => {
            //OKであろうがなんであろうが、reloadする
            //if (res === 'ok') {
            //現在のtofFrameNavigationのURLをリロードする
            //セッション（認証）が有効で無い場合、ログイン画面へリダイレクトされるだろう
            //その後、そのままログインすれば、現在のページに戻ってくる想定!!
            this.immediateRlead();
            //}
        });
    }


    /**
     * ブラウザを強制的にリロードする
     */
    static immediateRlead() {
        //現在のtopFrameNavigationのURLをリロードする
        //セッション（認証）が有効で無い場合、ログイン画面へリダイレクトされるだろう
        //その後、そのままログインすれば、現在のページに戻ってくる想定!!
        //編集状態の場合があるので、強制的にフラグを落とす
        Business.page.immediateEditCancel();
        window.location.reload();
    }

    /**
     * @async
     */
    static async getData(url: string, data?: any) {
        //return new Promise<object[]>((resolve, reject) => {
        return new Promise<any>((resolve, reject) => {
            Util.ajax({
                url: url,
                type: 'GET',
                data: data,
                //dataType: 'json',
            }).done(function (res) {
                // なぜjsonにならない？とりあえずparseする
                try {
                    res = JSON.parse(res) || {};
                    if (res.IsError) {
                        reject(res.StatusCode)
                    } else {
                        resolve(res.Data || [])
                    }
                } catch (e) {
                    //一旦エラーとする
                    reject();
                }
            }).fail(function (jqXHR, statusText, errorThrown) {
                reject(errorThrown);
            });
        });
    }

    /**
     * @async
     */
    static async postData(url: string, data?: any, isReturnRes?: boolean) {
        //return new Promise<object[]>((resolve, reject) => {
        return new Promise<any>((resolve, reject) => {
            Util.ajax({
                url: url,
                type: 'POST',
                data: data,
                //dataType: 'json',
            }).done(function (res) {
                // なぜjsonにならない？とりあえずparseする
                try {
                    res = JSON.parse(res) || {};
                    if (isReturnRes) {
                        resolve(res);
                    } else {
                        if (res.IsError) {
                            reject(res.StatusCode)
                        } else {
                            resolve(res.Data || [])
                        }
                    }
                } catch (e) {
                    //一旦エラーとする
                    reject();
                }
            }).fail(function (jqXHR, statusText, errorThrown) {
                reject(errorThrown);
            });
        });
    }

    /**
     * POSTリクエストする
     * @param String アクション
     * @param POSTデータ連想配列
     */
    static execPost(action, data?) {
        Util.request(action, 'post', data);
    }

    /**
     * Getリクエストする
     * @param String アクション
     * @param Object データ連想配列
     */
    static execGet(action, data?) {
        Util.request(action, 'get', data);
    }

    /**
     * リクエスト（TopFrameNavigationに対して）
     * @param 
     * @param action  url
     * @param method  
     * @param data POSTデータ連想配列
     * @param CSRF 
     */
    static request(action, method: 'post' | 'get' | 'put' | 'delete', data?, CSRF: boolean = true) {
        // フォームの生成
        const form = document.createElement("form");
        form.setAttribute("action", action);
        form.setAttribute("method", method);
        form.style.display = "none";
        document.body.appendChild(form);

        // パラメタの設定
        if (data !== undefined) {
            for (const paramName in data) {
                const input = document.createElement('input');
                input.setAttribute('type', 'hidden');
                input.setAttribute('name', paramName);
                input.setAttribute('value', data[paramName]);
                form.appendChild(input);
            }
        }

        //#1783 CSRF対策
        //通常リクエストの場合、POSTの場合のみCSRFトークンを付加する（getだとLocationにQueryStringとして出てしまう）
        if (method === 'post' && CSRF) {
            //cookieからCSRFトークン取得
            const csrfToken = Util.getCSRFToken();
            const input = document.createElement('input');
            input.setAttribute('type', 'hidden');
            //ASP.NETデフォルト'__RequestVerificationToken'。
            //Headerに含めず、リクエストリクエストに含める場合はこの名前、
            input.setAttribute('name', '__RequestVerificationToken');
            input.setAttribute('value', csrfToken);
            form.appendChild(input);
        }


        //セッションにプロジェクト情報を保持しなくなる為、プロジェクトコードを都度パラメータに含める
        if (method === 'post') {

            let projectId = Util.getProjectId();
            let input = document.createElement('input');
            input.setAttribute('type', 'hidden');
            input.setAttribute('name', '_projectId');
            input.setAttribute('value', projectId);
            form.appendChild(input);


            //ProjectCode取得
            const projectCode = Util.getProjectCode();
            input = document.createElement('input');
            input.setAttribute('type', 'hidden');
            input.setAttribute('name', '_projectCode');
            input.setAttribute('value', projectCode);
            form.appendChild(input);
        }

        // submit
        form.submit();
    }

    /**
     * 指定されたcookieを取得
     * (指定するcookie名はHttpOnlyがfalseである必要がある)
     * @param cname
     */
    static getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }


    /**
     * cookieからCSRFトークン取得
     * @param cname
     */
    static getCSRFToken() {
        //CSRF対策
        //Angularやaxiosに合わせておく
        //なぜX-XSRF-TOKENという名前にするかというと、Angularやaxiosなどのクライアントのajaxライブラリでは、レスポンスされたXSRF-TOKEN（cookieのXSRF-TOKEN）の値を、
        //リクエスト時にX - XSRF - TOKENという名前でリクエストヘッダに含める動作を自動的に行っているためです。
        //トークンの名前を合わせておけば、クライアント側でリクエストヘッダにXSRFトークンを追加するような処理を実装する必要がなくなります。
        //X-XSRF-TOKENのキー名でTokenをチェックさせます。
        return Util.getCookie("XSRF-TOKEN") || '';
    }


    /**
     * 画面埋め込みのProjectCodeを取得する
     * @param cname
     */
    static getProjectId() {
        //画面埋め込みのProjectCodeを取得する
        return ($('#_projectId').val() || '') + '';
    }

    /**
     * 画面埋め込みのProjectCodeを取得する
     * @param cname
     */
    static getProjectCode() {
        //画面埋め込みのProjectCodeを取得する
        return ($('#_projectCode').val() || '') + '';
    }

    /**
     * 
     */
    static readonly userAgent = {
        /**
         * 
         */
        isMobile: function () {

            //#5680 現在のipadのUAは、ChromeのほうにはUAにiPadが含まれているが、SafariだとUAにiPadが含まれていない
            //iPad Safariを判定に含めるにはmacintoshと'ontouchend' in documentをifの条件に加えれば判定できる。

            //if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
            //    return true;
            //} else {
            //    return false;
            //}
            const ua = navigator.userAgent.toLowerCase()
            if (/android|ipod|ipad|iphone|macintosh/.test(ua) && 'ontouchend' in document) {
                return true;
            } else {
                return false;
            }
        }
    };


    /***/
    static readonly screenMode = {
        /**
        * スクリーンのサイズを特定する
        * @param e
        */
        detectScreenMode: function (e?) {
            let tablet = 768; // タブレット
            let mobile = 576; // スマホ
            let width = $(window).width();
            $('body').removeAttr('data-screen');
            if (width <= mobile) {
                $('body').attr('data-screen', 'mobile');
            } else if (mobile < width && width <= tablet) {
                $('body').attr('data-screen', 'tablet');
            } else {
                $('body').attr('data-screen', 'desktop');
            }
        },

        /***/
        Mode: function (): 'mobile' | 'tablet' | 'desktop' {
            let screen = $('body').attr('data-screen');
            if (screen === 'mobile') {
                return 'mobile';
            } else if (screen === 'tablet') {
                return 'tablet';
            } else {
                return 'desktop';
            }
        },

        /***/
        isMobile: function () {
            return Util.screenMode?.Mode() === 'mobile';
        },

        /***/
        isTablet: function () {
            return Util.screenMode?.Mode() === 'tablet';
        },
        /***/
        isDesktop: function () {
            return Util.screenMode?.Mode() === 'desktop';
        }
    }

    /**
     * 日付関連Util
     */
    static readonly date = {

        /**
         * YYYYMMDD or YYYY/MM/DD形式
         * @param {any} date
         * @param {any} isSlash
         */
        getYYYYMMDD: function (date, isSlash?) {
            if (date == null || date == '') { return null; }
            const dt = new Date(date);
            const y = dt.getFullYear();
            const m = ('00' + (dt.getMonth() + 1)).slice(-2);
            const d = ('00' + dt.getDate()).slice(-2);

            if (isSlash) {
                return y + '/' + m + '/' + d;
            } else {
                return y + m + d;;
            }
        },

        /**
         * YYYYMMDD or YYYY/MM/DD形式の今日日付
         * @param {any} isSlash
         */
        getNowYYYYMMDD: function (isSlash?) {
            const dt = new Date();
            return this.getYYYYMMDD(dt, isSlash);
        },

        /**
         * yyyyMMddHHmmssの現在日時
         * */
        getNowYYYYMMDDHHMMSS: function () {
            var date = new Date();
            return date.getFullYear() + ('0' + (date.getMonth() + 1)).slice(-2) + ('0' + date.getDate()).slice(-2) + ('0' + date.getHours()).slice(-2) + ('0' + date.getMinutes()).slice(-2) + ('0' + date.getSeconds()).slice(-2);
        },

        /**
         * YYYYMMDD or YYYY/MM/DD形式の翌日日付日付
         * @param {any} isSlash
         */
        getNextDayYYYYMMDD: function (isSlash?) {
            const dt = new Date();
            dt.setDate(dt.getDate() + 1);
            return this.getYYYYMMDD(dt, isSlash);
        },

        /**
         * YYYY/MM/DD（AAA）形式
         * @param {any} date
         */
        getYYYYMMDDAAA: function (date) {
            if (date == null || date == '') { return null; }
            const dt = new Date(date);
            const y = dt.getFullYear();
            const m = ('00' + (dt.getMonth() + 1)).slice(-2);
            const d = ('00' + dt.getDate()).slice(-2);
            const w = dt.getDay();
            const wjp = ["日", "月", "火", "水", "木", "金", "土"][w];

            return y + '/' + m + '/' + d + '（' + wjp + '）';
        },

        /**
         * 日付の差
         * @param {any} _date1
         * @param {any} _date2
         */
        termDay: function (_date1, _date2?) {
            if (_date1 === null && _date2 === null) { return 0; }
            const date1 = new Date(_date1);
            const date2 = (_date2 == null) ? new Date(this.getNowYYYYMMDD(true)) : new Date(_date2);
            const termDay = (date2.valueOf() - + date1.valueOf()) / 86400000;
            //console.log(termDay);
            return termDay;
        },

        /**
         * 日付の間隔(差)
         * @param {any} _date1
         * @param {any} _date2
         */
        interval: function (_date1, _date2) {
            return Math.abs(this.termDay(_date1, _date2));
        },

        /**
         *  入力された値が日付形式になれるか
         * @param dateLike
         */
        isDate: function (dateLike) {
            if (_.isNil(dateLike)) { return false; }
            var dt: Date;
            if (_.isString(dateLike)) {
                let y: number = null;
                let m: number = null;
                let d: number = null;
                //'/'除去
                dateLike = dateLike.split('/').join('');
                //'-'除去
                dateLike = dateLike.split('-').join('');

                //if (dateLike.length >= 8) {
                //時刻が入ってきている場合はTruncateする
                if (dateLike.length > 8) {
                    dateLike = dateLike.substr(0, 8);
                }
                if (dateLike.length === 8) {
                    //YYYYMMDD
                    y = _.toSafeInteger(dateLike.substr(0, 4));
                    m = _.toSafeInteger(dateLike.substr(4, 2)) - 1; //1月は0から始まる為 -1 する。
                    d = _.toSafeInteger(dateLike.substr(6, 2));
                } else if (dateLike.length === 6) {
                    //YYYYMD
                    y = _.toSafeInteger(dateLike.substr(0, 4));
                    m = _.toSafeInteger(dateLike.substr(4, 1)) - 1; //1月は0から始まる為 -1 する。
                    d = _.toSafeInteger(dateLike.substr(5, 1));
                } else {
                    //それ以外はエラー
                    return false;
                }

                dt = new Date(y, m, d);
                if (dt.getFullYear() != y ||
                    dt.getMonth() != m ||
                    dt.getDate() != d) {
                    return false;
                }

            } else if (_.isDate(dateLike)) {
                dt = dateLike;
            }

            //有効なDateか判定
            if (_.isNaN(dt.getMilliseconds())) {
                return false;
            }
            if (dt < Util.MIN_DATETIME || Util.MAX_DATETIME < dt) {
                return false;
            }
            return true;
        },

        /**
          *  入力された値が日付でYYYY/MM/DD形式になっているか調べる
          * @param dateLike
          */
        isDateString: function (dateLike) {

            if (_.isNil(dateLike)) { return false; }

            //if (_.isDate(dateLike)) {
            //    //有効なDateか判定
            //    if (_.isNaN(dateLike.getMilliseconds())) {
            //        return false;
            //    }
            //}

            if (!dateLike.match(/^\d{4}\/\d{2}\/\d{2}$/)) { return false; }
            var y = dateLike.split("/")[0];
            var m = dateLike.split("/")[1] - 1;
            var d = dateLike.split("/")[2];
            var date = new Date(y, m, d);
            if (date.getFullYear() != y || date.getMonth() != m || date.getDate() != d) {
                return false;
            }
            return true;
        },

        /**
          *  入力された値が月日だけ、または年月日になっているか調べる
          * @param dateLike
          */
        isDateMDorYMD: function (dateLike) {
            if (_.isNil(dateLike)) { return false; }
            var dt: Date;
            if (_.isString(dateLike) || _.isNumber(dateLike)) {

                dateLike = dateLike.toString();

                // 区切り文字を統一してから分割する
                let splited: string[] = dateLike.replace("-", "/").split("/");

                if (splited.length == 3) {
                    // 年月日あり
                    if (!dateLike.match(/^\d{1,4}[\-\/]\d{1,2}[\-\/]\d{1,2}$/)) { return false; }

                } else if (splited.length == 2) {
                    // 月日のみ
                    if (!dateLike.match(/^\d{1,2}[\-\/]\d{1,2}$/)) { return false; }

                    // 当年の年度を先頭に付加する
                    const thisYear = new Date().getFullYear();
                    splited.unshift(thisYear.toString());

                } else {
                    // それ以外はエラー
                    return false;
                }

                const y = parseInt(splited[0], 10);
                const m = parseInt(splited[1], 10) - 1;
                const d = parseInt(splited[2], 10);
                dt = new Date(y, m, d);
                if (dt.getFullYear() != y || dt.getMonth() != m || dt.getDate() != d) {
                    return false;
                }
            } else if (_.isDate(dateLike)) {
                dt = dateLike;
            }

            //有効なDateか判定
            if (_.isNaN(dt.getMilliseconds())) {
                return false;
            }
            if (dt < Util.MIN_DATETIME || Util.MAX_DATETIME < dt) {
                return false;
            }
            return true;
        },

        /**
         * 時刻の妥当性チェックをする
         * @param str
         */
        isTime: function (str) {
            if (_.isNil(str)) { return false; }
            str += '';
            return str.match(/^([01]?[0-9]|2[0-3]):([0-5][0-9])$/) !== null;
        },

        /**
         * 入力された値が月日だけの場合に当年日付(YYYYY/MM/DD)に変換する
         * 元の値が年月日の場合はそのままの年度のYYYY/MM/DDで返却する
         * @param dateLike
         */
        convertMDtoYYYYYMMD: function (dateLike) {
            // 有効な日付でない場合は、元の値を返却する
            if (!this.isDateMDorYMD(dateLike)) { return dateLike; }

            let convertDateString = dateLike;
            if (_.isDate(dateLike)) {
                // Date型の場合
                convertDateString = this.getYYYYMMDD(dateLike, true);
            } else if (!_.isNil(dateLike)) {
                // Date型でない場合、文字列として処理
                let splited: string[] = dateLike.replace("-", "/").split("/");
                if (splited.length == 2) {
                    // 月日のみが入力されている場合は当年を付加する
                    convertDateString = new Date().getFullYear() + "/" + dateLike;
                }
                convertDateString = this.getYYYYMMDD(convertDateString, true);
            }
            return convertDateString;
        },

        /**
         * @param dateLike
         */
        toSafeDate: function (dateLike, truncate: boolean = true) {
            if (_.isNil(dateLike)) {
                return (truncate) ? null : dateLike;
            }
            let dt = new Date(dateLike);
            if (!_.isDate(dt)) {
                return (truncate) ? null : dateLike;
            }
            if (_.isNaN(dt.getMilliseconds())) {
                return (truncate) ? null : dateLike;
            }
            if (dt < Util.MIN_DATETIME || Util.MAX_DATETIME < dt) {
                return (truncate) ? null : dateLike;
            }
            return dt;
        }
    };


    /**
     * Date型をJSONで正しく扱える文字列に変換する
     *!!Excel Export 対応!!
     *getProductData内で、上手く帳尻合わせてしまうこととした！
     * @param list 
     * @deprecated
     */
    static convertDateToJSON(list: any[]) {
        // Date型をそのままjQuery.Ajaxに渡すと、toStringされて、 日付として解釈できないのでJSONの文字列に変換する

        //(new Date()).toString();
        // >>>"Wed Mar 10 2021 09:19:08 GMT+0900 (日本標準時)"←これでリクエストにのり、サーバーエラー
        //
        //(new Date()).toUTCString();
        // >>>"Wed, 10 Mar 2021 00:19:14 GMT"
        //
        // (new Date()).toGMTString();
        // >>>"Wed, 10 Mar 2021 00:19:23 GMT"
        //
        //(new Date()).toJSON()
        // >>>"2021-03-10T00:49:50.829Z"

        //Date インスタンスは、特定の時点を参照します。
        //toJSON() の呼び出しは、Date オブジェクトの値を表す文字列(toISOString() を使用) を返します。
        //このメソッドは、一般的に、JSON シリアライズを目的として Date オブジェクトをシリアライズするために使用されます。

        list.forEach((row, index) => {
            _.forOwn(row, function (item, key) {
                if (_.isDate(item)) {
                    //debugger;
                    //ただし上で述べたように JSON.stringify したときの文字列表現は ISO8601 になるが、タイムゾーンを無視して常に UTC になってしまう。
                    //var dt = new Date("2016-05-01T00:00+0900");
                    //dt.toJSON() => 2016 - 04 - 30T15: 00: 00Z
                    //タイムゾーン指定を見落とすと、指定した日時と異なる結果が返ったように見えます。
                    //row[key] = item.toJSON();
                    //チョット気持ち悪いので、toLocaleStringでもよいかも（マシンによっては狂うかもね）
                    row[key] = item.toLocaleString('ja-JP');
                }
            });
        });

        return list;
    };

    /**
    * メッセージ取得
    * @param {string} msgId メッセージID
    * @param {string[]} params プレースホルダに対応する文字列
    * @returns {string} Message.jsonに対応するメッセージ
    */
    static getMessage(msg: string, params?: any[]) {

        let r = msg;

        if (params) {
            params.forEach((param, i) => {
                r = r.replace(`{${i}}`, param);
            });
        }

        return r;
    };

    /**
    * ファイルサイズ確認
    * @param {number} size ファイルサイズ
    */
    static isFileSizeOverLimit(size: number): boolean {

        // 1024[byte]をベースに上限値を決める
        const limitSize = 1024 * 1024 * constant.MAX_FILESIZE;

        // ファイルサイズの判定
        const result = size >= limitSize
            ? true : false;

        return result;
    };

    /**
     * ファイルダウンロード
     * @param url
     * @param fileName
     */
    static downloadFile(url, fileName) {

        const csrfToken = Util.getCSRFToken();
        const projectId = Util.getProjectId();
        const projectCode = Util.getProjectCode();

        // ファイルダウンロード
        const a = document.createElement('a');
        a.href = url + '?fileName=' + fileName + '&_projectId=' + projectId + '&_projectCode=' + projectCode + '&_=' + csrfToken;
        document.body.appendChild(a);
        a.download = fileName;
        a.click();
        a.remove();

        // #3161【不具合：モ】ITB-06-002_1_1_6_9：Box連携画面のダウンロード時にシステムエラーが表示される
        // ダウンロードとAjaxがうまくいかないので、ダウンロード処理内でログを取るように変更
        // クライアントダウンロードではなくサーバーダウンロードなのでAjaxである必要はない
        //// ログ
        //Util.ajax({
        //    url: '/LogInfo/BoxDownloadLog',
        //    type: 'POST',
        //    data: { fileName: a.download }
        //});

    }



    /**
     * html関連
     */
    static readonly html = {
        /** 
          *  文字列エスケープ
          */
        escape: function (string) {
            string = string || '';
            return string.replace(/\&/g, '&amp;')
                .replace(/\</g, '&lt;')
                .replace(/\>/g, '&gt;')
                .replace(/\"/g, '&quot;')
                .replace(/\'/g, '&#x27');
        },

        /**
         * 改行タグ変換
         */
        nl2br: function (string) {
            string = string || '';
            string = string.replace(/\r\n/g, "<br>");
            string = string.replace(/(\n|\r)/g, "<br>");
            return string;
        }
    }

    /** 残業時間の選択肢 */
    static getOvertimeChoiceList() {
        return ["", "定時",
            "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00", "24:00",
            "翌1:00", "翌2:00", "翌3:00", "翌4:00", "翌5:00", "翌6:00", "翌7:00", "翌8:00", "翌9:00", "24h作業",
        ];
    }

    /**
     * ダウンロード
     * @param url
     * @param data
     */
    static download(url: string, data) {

        let result = 'success';

        return new Promise<any>(resolve => {
            this.ajax({
                url: url,
                type: 'POST',
                data: data,
                xhrFields: { responseType: 'blob' },
            }, false).done(function (data, textStatus, jqXHR) {

                const disposition = jqXHR.getResponseHeader('Content-Disposition');
                let fileName; // サーバー側で定義したファイル名を取得する
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    // 正規表現
                    var filenameRegex = /filename[^;=\n]=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        // matches[1]でとれる⇒ filename*=utf-8''201911%E3%83%87%E3%83%BC%E3%82%BF.csv;
                        // 不要文字列を消して、デコードしてサーバからのファイル名を取得
                        fileName = decodeURI(matches[1].replace(/['"]/g, '').replace('UTF-8', ''));
                    }
                }
                if (window.navigator.msSaveOrOpenBlob) {
                    // ↓ IEでのダウンロード
                    window.navigator.msSaveOrOpenBlob(data, fileName);
                    // ↓ IE以外でのダウンロード
                } else {
                    const blob = new Blob([data], { type: 'application/octet-binary' });
                    const downloadUrl = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = downloadUrl;
                    a.download = fileName;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                }
                resolve(result);
            })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    // #4792 戻り値はファイルが期待されている為、ファイル以外が返されるとエラー情報が拾えない
                    // Successで返してもparseerrorとなる。 その為、エラーダイアログは独自で作る。
                    result = 'error';
                    const date = new Date();
                    const nowTime = date.getFullYear() + '/' + ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + ' ' + ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2) + ':' + ('0' + date.getSeconds()).slice(-2);

                    if (jqXHR.status == 401) {
                        const title = jqXHR.status + ' Unauthorized'; // タイトルは「401 Unauthorized」
                        const message = '認証に失敗しました。';
                        const $errContainer = $(`<div class="mb-3">${message}</div><div>再度ログインしてください。</div><div>エラー発生日時：${nowTime}</div>`);
                        Dialog.MessgeDialog(title, $errContainer, (res) => {
                            Business.page.immediateEditCancel();
                            window.location.reload();
                        });
                        return;
                    } else {
                        // セッション切れ以外の場合、エラー情報が拾えない為、下記情報はクライアント側で作成する。
                        const title = 'システムエラー'; // タイトルは「システムエラー」
                        const message = 'システムエラーが発生しました。';
                        const $errContainer = $(`<div class="mb-3">${message}</div><div>システム管理者へお問い合わせ下さい。</div><div>エラー発生日時：${nowTime}</div>`);
                        Dialog.MessgeDialog(title, $errContainer, (res) => {

                        });
                    }

                    resolve(result);
                })
                .always(function (data, textStatus, errorThrown) {
                });
        });
    }

    /**
     * 全角数値リスト
     * 
     * */
    static befnum = new Array("０", "１", "２", "３", "４", "５", "６", "７", "８", "９");

    /**
     * 半角数値リスト
     * 
     * */
    static aftnum = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9");

    /**
     * 時刻hh:mm形式に変換する
     * @param value
     */
    static convertTimeString(value) {

        let convertTimeString = value;

        // 空白の場合、以下の処理はしない
        if (_.isNil(convertTimeString)) {
            return convertTimeString;
        }

        // 数値型の場合、文字列に変換する
        if (_.isNumber(convertTimeString)) {
            convertTimeString = convertTimeString.toString();
        }

        // 日付型の場合、hh:mm型にする
        if (_.isDate(convertTimeString)) {
            convertTimeString = ('0' + convertTimeString.getHours()).slice(-2) + ':' + ('0' + convertTimeString.getMinutes()).slice(-2);
        }

        // 全角数値を半角数値に変換する
        var bef = this.befnum;
        var aft = this.aftnum;
        for (var i = 0; i < aft.length; i++) {
            var reg = new RegExp(bef[i], "g");
            convertTimeString = convertTimeString.replace(reg, aft[i]);
        }

        // 全角で'：'の場合は半角':'にする
        convertTimeString = convertTimeString.replace('：', ':');

        return convertTimeString;
    }

    /**
     * 現在日付が指定した日（プロジェクト終了日）を過ぎているかチェック
     * */
    static isOverProjectEndDate(projectEndData: Date): boolean {

        let result = false;

        let nowDate = new Date(this.date.getNowYYYYMMDD(true));

        // 現在日付がプロジェクト終了日を過ぎているか
        if (projectEndData < nowDate) {
            result = true;
        }
        return result;
    }
}


